var React = require('react');

function MoreVertical (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("rect",{"width":"3","height":"3","y":"12","rx":"1.5","key":0}),React.createElement("rect",{"width":"3","height":"3","y":"6","rx":"1.5","key":1}),React.createElement("rect",{"width":"3","height":"3","rx":"1.5","key":2})]));
}

MoreVertical.defaultProps = {"width":"3","height":"15","viewBox":"0 0 3 15"};

module.exports = MoreVertical;

MoreVertical.default = MoreVertical;
